import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";
import { CalendarItemDatabase } from "../../../types";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";

async function fetchCalendarItems(
  minDate: string,
  maxDate: string,
  spaceId: string,
): Promise<CalendarItemDatabase[]> {
  const { data, error } = await apiClient
    .from('calendar_items')
    .select('*')
    .eq('space_id', spaceId)
    .lte('date', maxDate)
    .or(`end_date.gte.${minDate},and(end_date.is.null,date.gte.${minDate})`);

  if (error) {
    throw error;
  }

  return data;
}

export function useGetCalendarItems(minDate: string, maxDate: string) {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.getCalendarItemsByDate(minDate, maxDate, currentSpace?.id ?? ''),
    queryFn: () => fetchCalendarItems(minDate, maxDate, currentSpace!.id),
    enabled: !!minDate && !!maxDate && !!currentSpace?.id,
    staleTime: _3_DAYS,
    placeholderData: keepPreviousData,
  });
}
